import React, {Component} from 'react';

export default class SelectIcon extends Component {
	render() {
		return (
				<svg width="18" height="12" xmlns="http://www.w3.org/2000/svg">
					<path stroke="#191919" d="m1.728329,2.342463l7.156326,7.156326l7.156326,-7.156326l-14.312653,0z" transform="rotate(0.0000012223132443978102 9.502808570861816,6.283457273243177) " fill="#191919" strokeLinejoin="round" fillRule="evenodd"/>
				</svg>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Favourites/SelectIcon.js